var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 24,
    viewBox: "0 -960 960 960",
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M320-184.615v-391.001q0-26.846 19-45.615Q358-640 384.846-640h390.539q26.846 0 45.731 18.884Q840-602.231 840-575.385v278.462L663.077-120H384.615q-26.846 0-45.731-18.884Q320-157.769 320-184.615ZM121-696.154Q115.769-723 131.307-744.5q15.539-21.5 42.385-26.731L558.462-839q26.846-5.231 48.346 10.307 21.5 15.539 26.731 42.385L642-735.385h-40.462L593-783.077q-1.538-8.462-9.231-13.461-7.692-5-16.923-3.462l-386.077 68.539q-10.769 1.538-16.154 9.999-5.384 8.462-3.846 19.231l63.846 360.615v77.462q-13.692-6.692-23.269-19-9.577-12.307-12.577-28.23L121-696.154Zm239 120.769v390.77q0 10.769 6.923 17.692T384.615-160H640v-160h160v-255.385q0-10.769-6.923-17.692T775.385-600h-390.77q-10.769 0-17.692 6.923T360-575.385ZM580-380Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopics);
export default __webpack_public_path__ + "static/media/topics.7c5fb91236d8ebf8e6e04e104a4c446c.svg";
export { ForwardRef as ReactComponent };